import {
  Button,
  Carousel,
  FileInput,
  Select,
  TextInput,
  Textarea,
  Tooltip,
} from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import blankImage from '../../Assets/NoPhoto.jpg';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../Reducers/store';
import { HiEye } from 'react-icons/hi';
import { Manufacturer } from '../../Models/Manufacturer';
import ManufacturerApi from '../../Api/ManufacturerApi';
import { File as ImageFile } from '../../Models/File';
import CommonApi from '../../Api/CommonApi';
import { MdCancel } from 'react-icons/md';
import { FileTypeEnums } from '../../Models/FileType';
import Editor from '../Common/Editor';

export default function EditManufacturer() {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { states } = useAppSelector((state) => state.commonFields);
  const [manufacturerData, setManufacturerData] =
    useState<Manufacturer | null>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [imageFiles, setImageFiles] = useState<ImageFile[]>([]);
  const [quillValue, setQuillValue] = useState('');
  const [formData, setFormData] = useState<Manufacturer>({
    id: 0,
    name: '',
    address: '',
    city: '',
    stateId: null,
    zip: null,
    phone: '',
    email: '',
    description: '',
    website: '',
    rimssId: null,
    rimssOemvendorNumber: null,
    rimssPricebookId: null,
    active: null,
    parentManufacturerId: null,
    primaryImageURL: '',
    files: null,
    state: null,
  });
  const [file, setFile] = useState<File | null>();

  const getManufacturer = () => {
    if (id) {
      setIsLoading(true);
      ManufacturerApi.getManufacturer(id)
        .then((res) => {
          setManufacturerData(res.data);
          setQuillValue(res.data.description ?? '');
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } else {
      setManufacturerData(null);
    }
  };

  useEffect(() => {
    getManufacturer();
  }, [id]);

  useEffect(() => {
    // if (manufacturerData && userModel && id) {
    //   if (userModel.userLevelId !== UserLevelNames.SuperAdmin) {
    //     if (
    //       userModel.memberId !== manufacturerData.memberId ||
    //       (userModel.memberId === manufacturerData.memberId &&
    //         userModel.id !== Number(id) &&
    //         userModel.userLevelId !== UserLevelNames.MemberAdmin)
    //     ) {
    //       toast.error('You do not have access to this page');
    //       navigate(-1);
    //     }
    //   }
    // }
    handleSetInitialValues();
  }, [manufacturerData]);

  const handleSetInitialValues = () => {
    const values = manufacturerData
      ? {
          ...manufacturerData,
        }
      : {
          id: 0,
          name: '',
          address: '',
          city: '',
          stateId: null,
          zip: null,
          phone: '',
          email: '',
          description: '',
          website: '',
          rimssId: null,
          parentManufacturerId: null,

          files: null,
          state: null,
        };

    setImageFiles(values.files as ImageFile[]);
    setFormData(values as Manufacturer);
    setQuillValue(values.description ?? '');
  };

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  function handleImageChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.currentTarget.files) {
      setFile(event.currentTarget.files[0]);
    } else {
      setFile(null);
    }
  }

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    setButtonDisabled(true);
    e.preventDefault();
    let manufacturerUpdated = false;
    let imageUpdated = false;
    try {
      setIsLoading(true);
      formData.description = quillValue;
      await ManufacturerApi.addUpdateManufacturer(formData)
        .then((res) => {
          if (res.data.success) {
            manufacturerUpdated = true;
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          toast.error('Error: ' + err);
        });
      if (file) {
        const fd = new FormData();
        fd.append('file', file);
        fd.append('manufacturerId', formData.id.toString());
        await ManufacturerApi.uploadManufacturerImage(fd)
          .then((res) => {
            if (res.data.success) {
              imageUpdated = true;
            }
          })
          .catch((err) => {
            toast.error('Image Error: ' + err);
          });
      } else {
        imageUpdated = true;
      }
      setIsLoading(false);
      setButtonDisabled(false);
      if (manufacturerUpdated && imageUpdated) {
        toast.success('Save Success');
        setQuillValue('');
        navigate(`/manufacturer/${formData?.id}`);
      } else {
        toast.error('Error while saving');
      }
      return;
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      setButtonDisabled(false);
    }
  };

  function handleRemoveImage(id: number) {
    const shouldRemove = window.confirm(
      'Are you sure you want to delete this image?'
    );

    if (shouldRemove) {
      CommonApi.deleteFile(id)
        .then((res) => {
          if (res.data.success) {
            setImageFiles(imageFiles.filter((x) => x.id !== id));
            toast.success('Image deleted');
          } else {
            toast.success('Error while deleting image');
          }
        })
        .catch((err) => {
          toast.error('Image Error: ' + err);
        });
    }
  }

  return (
    <div className='w-full'>
      <div className='w-full p-4'>
        <div className='mx-1 flex items-end'>
          <div className='flex flex-1'>
            <h1 className='text-gray-900 font-bold text-4xl'>
              Edit Manufacturer Information
            </h1>
          </div>
          <div className='right-2'>
            <Link to={`/manufacturer/${manufacturerData?.id}`}>
              <Tooltip content='View'>
                <Button className='buttonMain'>
                  <HiEye size={20} />
                </Button>
              </Tooltip>
            </Link>
          </div>
        </div>
      </div>

      <div>
        <div className='container mx-auto p-2'>
          <div className='md:flex no-wrap md:-mx-2 '>
            <div className='w-full md:w-3/12 md:mx-2'>
              <div className='relative h-56 sm:h-64 xl:h-80 2xl:h-96 border-2 rounded-lg'>
                {imageFiles &&
                  imageFiles.filter((x) => x.fileTypeId === FileTypeEnums.Photo)
                    .length === 0 && (
                    <img
                      src={blankImage}
                      alt={'blank-image'}
                      className='h-56 sm:h-64 xl:h-80 2xl:h-96 object-contain m-auto'
                    />
                  )}
                {imageFiles &&
                  imageFiles.filter((x) => x.fileTypeId === FileTypeEnums.Photo)
                    .length > 0 && (
                    <Carousel slide={false} className=''>
                      {imageFiles
                        .sort(
                          (a, b) => Number(b.isPrimary) - Number(a.isPrimary)
                        )
                        .map((data) => (
                          <div key={data.id + '-div'} className='relative'>
                            <div className='w-full h-full text-center absolute top-2'>
                              <button
                                key={data.id + '-button'}
                                type='submit'
                                title='Delete Image'
                                onClick={() => handleRemoveImage(data.id)}
                                className=' rounded-full bg-white'
                              >
                                <MdCancel color='red' size={20} />
                              </button>
                            </div>
                            <div className=''>
                              <img
                                key={data.id}
                                src={data.fileUrl!}
                                alt={formData.name + '-image'}
                                className='h-56 sm:h-64 xl:h-80 2xl:h-96 object-contain m-auto'
                              />
                            </div>
                          </div>
                        ))}
                    </Carousel>
                  )}
              </div>
              <div>
                <FileInput
                  id='file-upload'
                  helperText='PNG or JPG.'
                  onChange={handleImageChange}
                  disabled={buttonDisabled}
                />
              </div>
            </div>
            <div className='w-full md:w-10/12 mx-2'>
              <div className='bg-white p-3'>
                <div className='flex items-center space-x-2 font-bold text-gray-500 leading-8 py-2'>
                  <span className='tracking-wide uppercase text-3xl'>
                    {manufacturerData?.name}
                  </span>
                </div>
                <hr className='bg-gray-300 h-[5px]'></hr>
                <form onSubmit={onSubmit}>
                  <div className='text-gray-500'>
                    <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] text-xl'>
                      <div className='flex'>
                        <div className='font-bold content-center'>Name:</div>
                      </div>
                      <div className='flex'>
                        <div className='w-1/2'>
                          <TextInput
                            id='name'
                            name='name'
                            type='text'
                            placeholder='Name...'
                            onChange={handleChangeInput}
                            value={formData.name ?? ''}
                            sizing='md'
                          />
                        </div>
                      </div>
                    </div>
                    <hr className='bg-gray-300 h-[2px]'></hr>
                    <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] text-xl'>
                      <div className='flex'>
                        <div className='font-bold content-center'>Email:</div>
                      </div>
                      <div className='w-1/2'>
                        <TextInput
                          id='email'
                          name='email'
                          type='text'
                          placeholder='Email Address...'
                          onChange={handleChangeInput}
                          value={formData.email ?? ''}
                          sizing='md'
                        />
                      </div>
                    </div>
                    <hr className='bg-gray-300 h-[2px]'></hr>
                    <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] text-xl'>
                      <div className='flex'>
                        <div className='font-bold content-center'>Phone:</div>
                      </div>
                      <div className='w-1/2'>
                        <TextInput
                          id='phoneNumber'
                          name='phoneNumber'
                          type='text'
                          placeholder='Phone...'
                          onChange={handleChangeInput}
                          value={formData.phone ?? ''}
                          sizing='md'
                        />
                      </div>
                    </div>
                    <hr className='bg-gray-300 h-[2px]'></hr>
                    <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] text-xl'>
                      <div className='flex'>
                        <div className='font-bold content-center'>Address:</div>
                      </div>
                      <div className='flex'>
                        <div className='w-1/3'>
                          <TextInput
                            id='address'
                            name='address'
                            type='text'
                            placeholder='Street...'
                            onChange={handleChangeInput}
                            value={formData.address ?? ''}
                            sizing='md'
                          />
                        </div>
                        <div className='w-2/3 flex'>
                          <div className='w-1/3'>
                            <TextInput
                              id='city'
                              name='city'
                              type='text'
                              placeholder='City...'
                              onChange={handleChangeInput}
                              value={formData.city ?? ''}
                              sizing='md'
                            />
                          </div>
                          <div className='w-1/3'>
                            <Select
                              id='stateId'
                              name='stateId'
                              onChange={handleChangeSelect}
                              value={formData.stateId ?? ''}
                              sizing='md'
                            >
                              <option>(State)</option>
                              {states.map((state) => (
                                <option key={state.id} value={state.id}>
                                  {state.name}
                                </option>
                              ))}
                            </Select>
                          </div>
                          <div className='w-1/3'>
                            <TextInput
                              id='zip'
                              name='zip'
                              type='text'
                              placeholder='Zip...'
                              onChange={handleChangeInput}
                              value={formData.zip ?? ''}
                              sizing='md'
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr className='bg-gray-300 h-[2px]'></hr>
                    <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] text-xl'>
                      <div className='flex'>
                        <div className='font-bold content-center'>
                          Rimss Id:
                        </div>
                      </div>
                      <div className='w-1/2'>
                        <TextInput
                          id='rimssId'
                          name='rimssId'
                          type='text'
                          placeholder='Rimss Id...'
                          onChange={handleChangeInput}
                          value={formData.rimssId ?? ''}
                          sizing='md'
                        />
                      </div>
                    </div>
                    <hr className='bg-gray-300 h-[2px]'></hr>
                    <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] text-xl'>
                      <div className='flex'>
                        <div className='font-bold content-center'>Website:</div>
                      </div>
                      <div className='w-1/2'>
                        <TextInput
                          id='website'
                          name='website'
                          type='text'
                          placeholder='Website...'
                          onChange={handleChangeInput}
                          value={formData.website ?? ''}
                          sizing='md'
                        />
                      </div>
                    </div>
                    <hr className='bg-gray-300 h-[2px]'></hr>
                    <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] text-xl'>
                      <div className='flex'>
                        <div className='font-bold content-center'>
                          Description:
                        </div>
                      </div>
                      <div>
                        <Editor
                          id='description'
                          name='description'
                          value={quillValue}
                          className='w-full'
                          changedValue={setQuillValue}
                        />
                        {/* <Textarea
                          id='description'
                          name='description'
                          placeholder='Description...'
                          onChange={handleChangeTextArea}
                          value={formData.description ?? ''}
                          rows={4}
                        /> */}
                      </div>
                    </div>
                  </div>
                  <div className='flex justify-end pt-2'>
                    <Button
                      disabled={buttonDisabled}
                      type='submit'
                      className='buttonMain'
                    >
                      Save
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
